import { ErrorIngredient } from "../CreateProductFlowInterfaces";

const isAllElementsEmpty = (arr: ErrorIngredient[]) => {
  for (const element of arr) {
    if (element !== null && element !== undefined &&
      (!Array.isArray(element) || element.length !== 0) &&
      (typeof element !== 'object' || Array.isArray(element) || Object.keys(element).length !== 0)) {
      return false;
    }
  }
  return true;
}

export default isAllElementsEmpty